if (!customElements.get('spazioil-video-gallery')) {
  class SpazioilVideoGallery extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.track = this.querySelector('[data-gallery-track]');
      this.videos = Array.from(this.querySelectorAll('[data-gallery-video]'));
      this.playButtons = Array.from(this.querySelectorAll('[data-gallery-play]'));
      this.previousButton = this.querySelector('[data-gallery-previous]');
      this.nextButton = this.querySelector('[data-gallery-next]');
      this.startMuted = this.dataset.startMuted !== 'false';

      this.onPlayClick = this.handlePlayClick.bind(this);
      this.onVideoPlay = this.handleVideoPlay.bind(this);
      this.onVideoPause = this.handleVideoPause.bind(this);
      this.onPreviousClick = () => this.scrollGallery(-1);
      this.onNextClick = () => this.scrollGallery(1);

      this.playButtons.forEach((button) => {
        button.addEventListener('click', this.onPlayClick);
      });

      this.videos.forEach((video) => {
        video.addEventListener('play', this.onVideoPlay);
        video.addEventListener('pause', this.onVideoPause);
        video.addEventListener('ended', this.onVideoPause);
      });

      this.previousButton?.addEventListener('click', this.onPreviousClick);
      this.nextButton?.addEventListener('click', this.onNextClick);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting && !entry.target.paused) {
                entry.target.pause();
              }
            });
          },
          { threshold: 0.15 }
        );

        this.videos.forEach((video) => this.observer.observe(video));
      }
    }

    disconnectedCallback() {
      this.playButtons?.forEach((button) => {
        button.removeEventListener('click', this.onPlayClick);
      });

      this.videos?.forEach((video) => {
        video.pause();
        video.removeEventListener('play', this.onVideoPlay);
        video.removeEventListener('pause', this.onVideoPause);
        video.removeEventListener('ended', this.onVideoPause);
      });

      this.previousButton?.removeEventListener('click', this.onPreviousClick);
      this.nextButton?.removeEventListener('click', this.onNextClick);
      this.observer?.disconnect();
      delete this.dataset.initialized;
    }

    handlePlayClick(event) {
      const card = event.currentTarget.closest('.spazioil-video-card');
      const video = card?.querySelector('[data-gallery-video]');
      if (!video) return;

      this.pauseAll(video);
      video.muted = this.startMuted;
      video.controls = true;

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          card.classList.remove('is-playing');
        });
      }
    }

    handleVideoPlay(event) {
      this.pauseAll(event.currentTarget);
      event.currentTarget.closest('.spazioil-video-card')?.classList.add('is-playing');
    }

    handleVideoPause(event) {
      event.currentTarget.closest('.spazioil-video-card')?.classList.remove('is-playing');
    }

    pauseAll(activeVideo) {
      this.videos.forEach((video) => {
        if (video !== activeVideo && !video.paused) video.pause();
      });
    }

    scrollGallery(direction) {
      if (!this.track) return;

      const card = this.track.querySelector('.spazioil-video-card');
      if (!card) return;

      const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({
        left: direction * (card.getBoundingClientRect().width + gap),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
  }

  customElements.define('spazioil-video-gallery', SpazioilVideoGallery);
}
